var module = 'hospitalBooking', name = 'hospital-booking/config/locales/fr_CA.json', content = {
  "hospital_booking": {
    "action_feedback": {
      "confirm": "Merci d'avoir confirmé votre présence",
      "confirm_subtitle": "",
      "cancel": "La demande d'annulation a été envoyée.",
      "cancel_subtitle": "",
      "call_back": "Nous avons bien reçu votre demande pour être joint",
      "call_back_subtitle": "Vous recevrez un appel de la clinique sous peu.",
      "transfer": "Nous avons bien reçu votre demande pour déplacer le rendez-vous",
      "transfer_subtitle": "Vous recevrez un appel de la clinique sous peu pour déplacer votre rendez-vous.",
      "unavailable": "L'option sélectionnée n'est plus disponible",
      "unavailable_subtitle": "Veuillez contacter la clinique pour plus d'informations."
    },
    "confirm_action": {
      "confirm": "Êtes-vous certain de vouloir confirmer ce rendez-vous?",
      "cancel": "Êtes-vous certain de vouloir annuler ce rendez-vous?",
      "call_back": "Êtes-vous certain de vouloir demander à être joint à propos de ce rendez-vous?",
      "transfer": "Êtes-vous certain de vouloir demander à déplacer ce rendez-vous?"
    },
    "execute_action": {
      "title": "Choisissez une des actions suivantes",
      "cancel": "Demander d'annuler le rendez-vous",
      "confirm": "Confirmer ma présence",
      "call_back": "Demander à être joint",
      "transfer": "Déplacer le rendez-vous"
    }
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./hospital-booking/config/locales/fr_CA.json
// module id = 778
// module chunks = 0